import { getPersonaPillSuggestionsInSearchTable } from './getPersonaPillSuggestionsInSearchTable';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
// 1.) Search scenario: render the header if a more than one persona pills are present in the store.
// 2.) Favorite PDL scenario: Favorite PDL is selected and we are showing emails from persona search folder
export function shouldShowMultiPersonaHeader(isSearchTable, tableViewId, selectedNode) {
    if (!isControlFeatureEnabled('peo-favoritePdls')) {
        return false;
    }
    if (selectedNode.type === 5 /* PrivateDistributionList */) {
        return true;
    }
    if (isSearchTable) {
        var personaPills = getPersonaPillSuggestionsInSearchTable(tableViewId);
        return personaPills && personaPills.length > 1;
    }
    return false;
}
//# sourceMappingURL=shouldShowMultiPersonaHeader.js.map